import zlib from 'zlib';
import { Buffer } from 'buffer';

export default {
  decompress (input) {
    const base64Encoded = input.replaceAll('.', '/').replaceAll('-', '+').replaceAll('_', '=');
    const compressed = Buffer.from(base64Encoded, 'base64')
    const decompressed = zlib.gunzipSync(compressed);
    return decompressed.toString();
  },
  compress (input) {
    const compressed = zlib.gzipSync(input);
    const base64Encoded = Buffer.from(compressed).toString('base64');
    return base64Encoded.replaceAll('/', '.').replaceAll('+', '-').replaceAll('=', '_');
  }
};
